import WebRoute from "./router";
import MainToastContainer from "./shared/components/MainToastContainer";

const App = () => {
    return (
        <>
            <WebRoute></WebRoute>

            {/* Container for rendering toasts from react-toastify, there should only be one per app */}
            <MainToastContainer />
        </>
    );
};

export default App;
